import { Link, NavLink, useNavigate } from "react-router-dom";
import { Lens } from "./Lens";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";

export function Header() {
  const { user, signOut, loading } = useAuth();
  const navigate = useNavigate();

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    cn("text-sm transition", isActive ? "text-neutral-900 font-medium" : "text-neutral-600 hover:text-neutral-900");

  return (
    <header className="border-b border-neutral-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 font-semibold text-lg">
          <Lens className="h-6 w-6 text-brand" />
          <span>DocLens</span>
        </Link>

        <nav className="flex items-center gap-6">
          <NavLink to="/pricing" className={linkClass}>Pricing</NavLink>
          <NavLink to="/api" className={linkClass}>API</NavLink>
          {!loading && user && (
            <NavLink to="/billing" className={linkClass}>Billing</NavLink>
          )}

          {!loading && !user && (
            <Link
              to="/login"
              className="text-sm rounded-lg bg-brand text-white px-4 py-2 font-medium hover:bg-brand-700 transition"
            >
              Sign in
            </Link>
          )}

          {!loading && user && (
            <div className="flex items-center gap-3">
              <span className="text-xs text-neutral-500 hidden md:inline">{user.email}</span>
              <button
                onClick={async () => {
                  await signOut();
                  navigate("/");
                }}
                className="text-sm text-neutral-600 hover:text-neutral-900"
              >
                Sign out
              </button>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
}
